import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { BASE_SPACING_X } from 'HubStyleTokens/sizes';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import styled from 'styled-components';
import UIAccordionItem from '../accordion/UIAccordionItem';
import UICardSection from '../card/UICardSection';
import AbstractTextElement from '../elements/AbstractTextElement';
import UIFlex from '../layout/UIFlex';
import { allSizes, toShorthandSize } from '../utils/propTypes/tshirtSize';
import omit from '../utils/underscore/omit';
const headingForSize = {
  xs: 'span',
  sm: 'h5',
  md: 'h4',
  lg: 'h2',
  xl: 'h1'
};
const Toolbar = styled.div.withConfig({
  displayName: "UICardHeader__Toolbar",
  componentId: "fnpnkr-0"
})(["flex:1 0 auto;text-align:right;margin-left:", ";"], BASE_SPACING_X);
const UICardHeader = /*#__PURE__*/forwardRef((props, ref) => {
  const _ref = props,
        {
    className,
    expanded,
    onExpandedChange,
    title,
    titleSize,
    toolbar
  } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, ["className", "expanded", "onExpandedChange", "title", "titleSize", "toolbar"]);

  const isExpander = typeof onExpandedChange === 'function';
  const shorthandSize = toShorthandSize(titleSize);
  const renderedTitle = isExpander ? /*#__PURE__*/_jsx(UIAccordionItem, {
    className: "private-card__title",
    flush: true,
    onOpenChange: onExpandedChange,
    open: expanded,
    title: title,
    size: shorthandSize
  }) : /*#__PURE__*/_jsx(AbstractTextElement, {
    className: "private-card__title",
    tagName: headingForSize[shorthandSize],
    children: title
  });
  return /*#__PURE__*/_jsx(UICardSection, Object.assign({}, rest, {
    ref: ref,
    className: classNames('private-card__header', className),
    isHeader: true,
    children: /*#__PURE__*/_jsxs(UIFlex, {
      align: "start",
      justify: "between",
      children: [renderedTitle, toolbar && expanded ? /*#__PURE__*/_jsx(Toolbar, {
        className: "private-card__toolbar private-card__title",
        children: toolbar
      }) : null]
    })
  }));
});
UICardHeader.propTypes = Object.assign({}, omit(UICardSection.propTypes, ['children']), {
  expanded: PropTypes.bool.isRequired,
  onExpandedChange: PropTypes.func,
  title: PropTypes.node,
  titleSize: allSizes,
  toolbar: PropTypes.node
});
const defaultProps = {
  expanded: true,
  titleSize: 'md'
};
UICardHeader.defaultProps = defaultProps;
UICardHeader.displayName = 'UICardHeader';
export default UICardHeader;